import type { QueryClient } from '@tanstack/react-query'
import {
  getPublishedFlashcardCategories,
  getPublishedFlashcards,
  type FlashcardCard,
  type FlashcardCategory,
} from '@services/firebase/flashcards'

const FLASHCARD_CATALOG_VERSION = 'v1'
const FLASHCARD_STALE_TIME_MS = 5 * 60 * 1000
const FLASHCARD_GC_TIME_MS = 10 * 60 * 1000

export const flashcardQueryKeys = {
  all: ['flashcards', FLASHCARD_CATALOG_VERSION] as const,
  cards: (categoryId: string) =>
    [...flashcardQueryKeys.all, 'cards', categoryId] as const,
  categories: () => [...flashcardQueryKeys.all, 'categories'] as const,
}

export function getFlashcardCategoriesQueryOptions() {
  return {
    gcTime: FLASHCARD_GC_TIME_MS,
    queryFn: getPublishedFlashcardCategories,
    queryKey: flashcardQueryKeys.categories(),
    staleTime: FLASHCARD_STALE_TIME_MS,
  }
}

export function getFlashcardCardsQueryOptions(categoryId: string) {
  return {
    gcTime: FLASHCARD_GC_TIME_MS,
    queryFn: () => getPublishedFlashcards(categoryId),
    queryKey: flashcardQueryKeys.cards(categoryId),
    staleTime: FLASHCARD_STALE_TIME_MS,
  }
}

export function prefetchFlashcardCards({
  categoryId,
  queryClient,
}: {
  readonly categoryId: string
  readonly queryClient: QueryClient
}): Promise<void> {
  return queryClient
    .prefetchQuery<FlashcardCard[]>(getFlashcardCardsQueryOptions(categoryId))
    .then(() => undefined)
}

export type { FlashcardCard, FlashcardCategory }
